<template>
    <div class="container" :style="{ 'width': props.widthOverride || '' }">
        <ActivityIndicator v-if="showActivityIndicator"/>
        <div class="title">{{ props.title }}</div>
        <div class="body">
            <slot name="body"></slot>
        </div>
        <div class="footer">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script setup>
    import { defineProps, ref, defineExpose } from 'vue';
    import ActivityIndicator from './ActivityIndicator.vue';

    const showActivityIndicator = ref(false);

    const props = defineProps({
        title: {
            type: String,
            default: ''
        },

        widthOverride: {
            type: String,
            default: null
        }
    });

    defineExpose({
        showActivityIndicator
    });
</script>

<style scoped>
    .container {
        display: flex;
        flex-direction: column;
        position: relative;
        max-height: 100%;
        width: 800px;
        overflow-y: scroll;
        border: 1px solid #aeaeae;
        background-color: white;
        border-radius: 7px;
        overflow: hidden; /* otherwise square corners of title box will show behind rounded coners of parent */
    }

    .title {
        font-size: 20px;
        border-bottom: solid #d8d6d6 1px;
        padding: 25px;
        background-color: #ededed;
    }

    .body {
        border-bottom: solid #c7c6c6 1px;
        padding: 25px;
        overflow: scroll;
    }

    .footer {
        display: flex;
        flex-direction: row;
        justify-content: right;
        padding: 25px;
    }
</style>
